module.exports = "- Announce when each individual page section has loaded, unless it has been over a specified period of time.\n"